// src/pages/OnlineUsersPage/index.js
import React from "react";
import { Card, List, Avatar, Tag, Typography, Empty, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useOnlineUsers, useOnlineCount } from "../../hooks/usePresence";

const { Title } = Typography;

export default function OnlineUsersPage() {
  // ❗React Hooks は常にコンポーネントのトップレベルで呼ぶ必要がある
  //   → 条件付きで呼ぶと ESLint のエラー（rules-of-hooks）になるため注意
  const { users } = useOnlineUsers(120000);   // staleMs=2分（見やすさ優先）
  const { count } = useOnlineCount(120000);

  return (
    <Card>
      {/* タイトルと総数バッジ */}
      <Space style={{ width: "100%", justifyContent: "space-between", alignItems: "baseline" }}>
        <Title level={4} style={{ marginBottom: 12 }}>
          オンライン中のユーザー
        </Title>
        {/* 総オンライン人数（ユーザーIDで重複排除済み） */}
        <Tag color="blue" style={{ fontWeight: 600 }}>総数: {count}</Tag>
      </Space>

      {/* ユーザーリスト（最新 lastSeen のみを採用） */}
      {users.length === 0 ? (
        <Empty description="現在オンラインのユーザーはいません" />
      ) : (
        <List
          dataSource={users}
          renderItem={(u) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={u.photoURL} icon={<UserOutlined />} />}
                title={
                  <span style={{ fontWeight: 600 }}>
                    {u.displayName || u.userId} <Tag color="green">online</Tag>
                  </span>
                }
                description={
                  <span style={{ color: "#666" }}>
                    {/* 任意項目：クラス名／出席番号などを表示 */}
                    {u.className ? `クラス: ${u.className}` : ""}
                    {u.regNumber ? (u.className ? " ／ " : "") + `出席番号: ${u.regNumber}` : ""}
                  </span>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
}
